import moduleName from '../moduleName';

export default {
  RETRIEVE_SITES: `${moduleName}/retrieveSites`,
  RETRIEVE_SITE: `${moduleName}/retrieveSite`,
  SET_SELECTED: `${moduleName}/setSelected`,
};
